import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { saveAs } from 'file-saver';
import kebabCase from 'lodash/kebabCase';
import {
  Field2 as Field,
  VibeButton,
  VibeIcon,
  viClose,
  color,
} from 'vibeguide';
import './DownloadCut.scss';

class DownloadCut extends PureComponent {
  constructor(props) {
    super(props);

    const {
      user,
      roughCutUrl,
      finalCutUrl,
    } = props;

    const isContentCurator = user.can('message.content_curator');
    const canDownloadRough = roughCutUrl && isContentCurator;
    const canDownloadFinal = finalCutUrl;

    this.state = {
      cutType: canDownloadRough
        ? 'rough'
        : 'final',
      canDownloadRough,
      canDownloadFinal,
    };
  }

  onDownload = () => {
    const {
      messageName,
      roughCutUrl,
      finalCutUrl,
    } = this.props;

    const {
      cutType,
    } = this.state;

    const url = cutType === 'rough'
      ? roughCutUrl
      : finalCutUrl;

    const fileName = `${kebabCase(messageName)}-${cutType}-cut`;
    saveAs(url, fileName);
  };

  setCutRough = () => {
    this.setState({
      cutType: 'rough',
    });
  };

  setCutFinal = () => {
    this.setState({
      cutType: 'final',
    });
  };

  render() {
    const {
      onClose,
    } = this.props;

    const {
      cutType,
      canDownloadRough,
      canDownloadFinal,
    } = this.state;

    return (
      <div className="DownloadCut">
        <div className="header">
          <div className="title">
            Please select the cut type
          </div>

          <VibeIcon
            className="close"
            icon={viClose}
            color={color.manatee}
            hoverColor={color.obsidian}
            size={24}
            data-testid="download-cut-close-button"
            onClick={onClose}
          />
        </div>

        <div
          className="content"
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 16,
          }}
        >
          <Field
            type="radio"
            label="Rough Cut"
            radioProps={{
              selected: cutType === 'rough',
            }}
            disabled={!canDownloadRough}
            testId="download-cut-rough-option"
            onClick={this.setCutRough}
          />

          <Field
            type="radio"
            label="Final Cut"
            radioProps={{
              selected: cutType === 'final',
            }}
            disabled={!canDownloadFinal}
            testId="download-cut-final-option"
            onClick={this.setCutFinal}
          />
        </div>

        <div className="footer">
          <VibeButton
            text="Download"
            color="primary"
            testId="download-cut-download-button"
            onClick={this.onDownload}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.login.user,
  };
}

export default connect(mapStateToProps)(DownloadCut);
